import type { FreshnessCache } from './freshnessCache';

/**
 * Caducado no es borrado (spec 2026-10-01 § 7).
 *
 * Fase 3a apagaba la lectura que BORRABA de la librería mientras no había
 * servidor. Fase 3b (esta) cambia la caché por `FreshnessCache`, que nunca borra
 * al leer: aquí solo queda decidir si lo caducado se vuelve a pedir (con
 * servidor) o se sirve tal cual (sin él, sin esperar a que la red falle).
 */

/** Edad a partir de la cual un dato se vuelve a pedir cuando hay red (el TTL de siempre). */
export const CACHE_FRESHNESS_MS = 3 * 3600 * 1000;

/**
 * Tiempo sin respuesta de red tras el que un dato se quita de la caché.
 * Decisión por defecto del spike (2026-10-01): 7 días. Una tablet sin
 * cobertura más tiempo que eso arranca en frío, como hoy pasados 3 h.
 */
export const CACHE_RETENTION_MS = 7 * 24 * 3600 * 1000;

/** Cada cuánto se pasa la retención con la app abierta (el WebView no se cierra). */
export const RETENTION_SWEEP_MS = 3600 * 1000;

export function applyFreshnessPolicy(
  cache: Pick<FreshnessCache, 'enforceFreshness'>,
  online: boolean,
): void {
  cache.enforceFreshness(online);
}
